<template>
  <div v-for="(stat, index) in stats" :key="index" class="row card mb-4">
    <div class="card-header">
      <h5 class="text-center">{{ departs.find(e => e.id === stat.departId)?.name }}</h5>
    </div>
    <div  v-for="(report, index) in stat.report" :key="index" class="">
      <div class="my-2 text-center">
        <h5 class="">{{ $appType.full[report.appType] }}</h5>
      </div>
      <div class="card-body row row-cols-lg-4 row-cols-md-2">
        <div class="mb-3">
          <div class="card text-center shadow-sm">
            <div class="card-body">
              <h5 class="card-title">{{ arriveLables[report.appType] }}</h5>
              <p class="card-text display-5 text-primary">{{ report.daily.departVehicles }} <span
                  class="fs-8 text-secondary">هذا اليوم</span></p>
              <hr />
              <p class="card-text display-5 text-primary">{{ report.monthly.departVehicles }} <span
                  class="fs-8 text-secondary">هذا الشهر</span></p>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="card text-center shadow-sm">
            <div class="card-body">
              <h5 class="card-title">المركبات العائدة</h5>
              <p class="card-text display-5 text-primary">{{ report.daily.returnVehicles }} <span
                  class="fs-8 text-secondary">هذا اليوم</span></p>
              <hr />
              <p class="card-text display-5 text-primary">{{ report.monthly.returnVehicles }} <span
                  class="fs-8 text-secondary">هذا الشهر</span></p>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="card text-center shadow-sm">
            <div class="card-body">
              <h5 class="card-title">إجمالي دخل الخدمات الإلكترونية</h5>
              <p class="card-text display-5 text-primary">{{ report.daily.totalReceiptIncome.toLocaleString() }} د <span
                  class="fs-8 text-secondary">هذا اليوم</span></p>
              <hr />
              <p class="card-text display-5 text-primary">{{ report.monthly.totalReceiptIncome.toLocaleString() }} د <span
                  class="fs-8 text-secondary">هذا الشهر</span></p>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="card text-center shadow-sm">
            <div class="card-body">
              <h5 class="card-title">اجمالي الطلبات المُقدمة</h5>
              <p class="card-text display-5 text-primary">{{ report.daily.totalApplicant }} <span
                  class="fs-8 text-secondary">هذا اليوم</span></p>
              <hr />
              <p class="card-text display-5 text-primary">{{ report.monthly.totalApplicant }} <span
                  class="fs-8 text-secondary">هذا الشهر</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <BarChart :data="" /> -->
<script>
import { mapGetters, mapActions } from 'vuex';
// import BarChart from '../BarChart.vue';
export default {
  data() {
    return {
      stats: [],
      departs: [],
      vehicles: [], // List of vehicles
      filteredVehicles: [], // Filtered list for search
      searchQuery: "", // Search box input
      arriveLables: ["", "عدد المركبات المغادرة", "عدد المركبات الداخلة"],
    };
  },
  // components: {
  //   BarChart,
  // },
  computed: {
    ...mapGetters(['getDeparts'])
  },
  created() {
    this.fetchOptions()
    this.fetchAllStats()
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
    ]),
    /********************************/
    async fetchOptions() {
      if (this.getDeparts.length == 0) {
        await this.fetchDeparts(); // Fetch and store in Vuex
      }
      this.departs = this.getDeparts
    },

    /********************************/
    /** */
    async fetchAllStats() {
      try {
        const summeryResponse = await this.$axios.get("api/employee/report/statssummary")

        if (summeryResponse?.data.isSuccess) {
          const summeryData = summeryResponse.data.data;

          this.stats = summeryData
          console.log("", this.stats)
        } else {
          this.$tempAlert(summeryResponse?.data.msg, 'warning');
        }
      } catch (error) {
        if (error.summeryResponse?.data) {
          this.$tempAlert(error.summeryResponse?.data.msg, 'warning');
        }
        console.error("Error fetching privileges and groups:", error);
      }
    },
    /******************************/

  },
};
</script>

<style scoped>
.dashboard-container {
  background-color: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.card {
  border-radius: 15px;
}

.table {
  margin: 0;
}

.table th {
  text-align: center;
}

.table td {
  vertical-align: middle;
}

.badge {
  font-size: 0.9rem;
}

.btn {
  font-size: 0.85rem;
}
</style>